export default {
  nav: {
    home: 'Inicio',
    video: 'Videovigilancia',
    alarm: 'Sistemas de Alarma',
    solutions: 'Soluciones',
    care: 'SSG Care',
    planner: 'Planificador de Cámaras',
    areas: 'Zonas de Servicio',
    about: 'Sobre Nosotros',
    contact: 'Contacto',
  },
  dropdown: {
    allSolutions: 'Ver todas las soluciones',
    homeGrounds: 'Hogar y Terreno',
    retailGastro: 'Comercio y Hostelería',
    officePractice: 'Oficina y Consulta',
    warehouseLogistics: 'Almacén y Logística',
    workshopTrade: 'Taller y Comercio',
    apartments: 'Edificios de Viviendas e Inmuebles',
    cameraTypes: 'Tipos de Cámaras',
    services: 'Servicios',
    technology: 'Tecnología',
  },
  footer: {
    brandLine: 'Tecnología de seguridad para particulares y empresas',
    area: 'Hainburg · Región Rin-Meno',
    services: 'Servicios',
    solutions: 'Soluciones',
    forWhom: 'Para Quién',
    contact: 'Contacto',
    areaLabel: 'Zona de servicio Rin-Meno',
    privateCustomers: 'Clientes particulares',
    businessCustomers: 'Clientes empresariales',
    allSolutions: 'Todas las soluciones',
    faq: 'Preguntas frecuentes',
    rights: 'Todos los derechos reservados.',
    impressum: 'Aviso legal',
    privacy: 'Política de privacidad',
    cookieSettings: 'Configuración de cookies',
  },
  related: {
    eyebrow: 'Más soluciones',
    title: 'Descubrir otros tipos de inmueble',
    viewAll: 'Ver todas las soluciones',
  },
};